import { Inject, Injectable } from '@angular/core';
import { IConfig } from '../interfaces/config.interface';


@Injectable({
    providedIn: 'root'
})
export class HeapIoService {
    isDeepLink: boolean;
    isBuyNow: boolean;
    version: string;
    source: string;
    appName: string;
    isStandalone: boolean;
    isLegacyCreditApp: boolean;
    isModalPrequal: boolean;
    buyNowVersion: string = '1';

    constructor(@Inject('config') public config: IConfig,) {
        const { source, appName } = this.getSourceAndAppname();
        this.source = source;
        this.appName = appName;

        this.isDeepLink = !!this.config?.Sitecore?.PreQualLeadInfo?._isDeepLink;
        this.isBuyNow = this.config?.Sitecore?.isBuyNow;

        this.isStandalone = this.config?.Sitecore?.IsStandAlonePreQual;
        // conflicting flags, standalone and modal...
        this.isModalPrequal = !this.config?.Sitecore?.IsContactStore && this.config?.Sitecore?.IsPrequalification && !!this.config?.Sitecore?.apiDomain;

    }



    public trackSubmit(data) {
        if (typeof (data) === 'string') {
            if (this.isBuyNow && data.indexOf('Backend returned code 0') >= 0) {
                //TBD: what to track here
            }
            return;
        }
        this.trackPageview('contact-information/pre-qual-results');

    }

    public trackPageview(pageName?: string, properties?: any) {
        const heap = (window as any).heap;
        if (heap?.trackPageview) {
            //scenario of closing modal instance
            if (pageName === 'close') {
                heap.track('close modal for Pre-qualification');
                heap.trackPageview({ close: true });
                console.log('heap.io trackPageview (close)');
                return;
            }

            const pageviewProperties = {
                url: this.getUrlProperty(pageName),
                properties: {
                    isDeepLink: this.isDeepLink,
                    isHybrid: this.isModalPrequal,
                    isBuyNow: this.isBuyNow,
                    source: this.source,
                }
            };
            if (this.isBuyNow) {
                pageviewProperties.properties['buyNow-Version'] = this.buyNowVersion;
            }
            if (properties) {
                pageviewProperties.properties = { ...pageviewProperties.properties, ...properties };
            }

            heap.trackPageview(pageviewProperties);
            console.log('heap.io trackPageview ', pageviewProperties);
        }
    }

    public track(event: string, data: any) {
        const heap = (window as any).heap;
        if (heap?.track) {
            heap.track(event, data);
        }
    }

    private getUrlProperty(pageName) {

        pageName = pageName || '';

        let prefix = this.getEnvironment().replace(/\/$/, '');
        let url = `${prefix}/${this.appName}/${pageName}`;
        return url;
    };


    private getEnvironment() {
        return (window as any)?.top?.location?.origin;
    }

    private getSourceAndAppname() {
        const pathname = (window as any)?.top?.location?.pathname;
        let source;
        let appName;
        if (pathname === '/') {
            source = 'HOME';
            appName = '';
        }
        else if (pathname.toLowerCase().indexOf('/cars/') === 0) {
            source = 'VDP';
            appName = 'cars';
        }
        else if (pathname.toLowerCase().indexOf('/cars-for-sale') === 0) {
            source = 'SRP';
            appName = 'cars-for-sale';
        }
        else if (pathname.toLowerCase().indexOf('/new-cars') === 0) {
            source = 'SRP';
            appName = 'new-cars';
        }
        else if (pathname.toLowerCase().indexOf('/used-cars') === 0) {
            source = 'SRP';
            appName = 'used-cars';
        }
        else if (pathname.toLowerCase().indexOf('/dealers/') === 0) {
            source = 'FAS';
            appName = 'dealers';
        }
        else if (pathname.toLowerCase().indexOf('/sell-my-car') === 0) {
            source = 'SMC';
            appName = 'sell-my-car';
        }
        else if (pathname.toLowerCase().indexOf('/track-car-value') === 0) {
            source = 'TCV';
            appName = 'track-car-value';
        }
        else if (pathname.toLowerCase().indexOf('/appointment') === 0) {
            source = 'APPOINTMENT';
            appName = 'appointment';
        }
        else if (pathname.toLowerCase().indexOf('/my-account') === 0) {
            source = 'MYACCOUNT';
            appName = 'my-account';
        }
        else if (pathname.toLowerCase().indexOf('/payment-calculator') === 0) {
            source = 'CPC';
            appName = 'payment-calculator';
        }
        else if (pathname.toLowerCase().indexOf('/pre-qualification') === 0) {
            source = 'PREQUAL';
            appName = 'pre-qualification';
        }
        else if (pathname.toLowerCase().indexOf('/buy-now') === 0) {
            source = 'BUYNOW';
            appName = 'buy-now';
        }
        return {
            source,
            appName
        };
    }




}